// import React from "react";
// import { 
//   PreviewIcon, 
//   RenameIcon, 
//   DownloadIcon, 
//   DeleteIcon, 
//   ViewIngestIcon,
//   MoveFolderIcon 
// } from "./Icons";

// const ActionMenu = ({ 
//   item, 
//   position, 
//   menuRef, 
//   setSelectedFilePreview, 
//   handleRenameClick, 
//   handleDownload, 
//   handleDelete,
//   handleViewAndIngest, 
//   handleSingleMoveToFolder, 
//   isAllFilesView, 
//   closeMenu 
// }) => {
//   const showMoveToFolder = isAllFilesView && !item.isFolder;
  
//   // FIX: Check if the document's status is "ingested"
//   const isIngested = item?.status?.toLowerCase() === "ingested";

//   return (
//     <div
//       className="fixed z-[9999] w-44 p-1.5 bg-white border border-[#E5E7EB] rounded-lg shadow-lg flex flex-col gap-0.5"
//       style={{
//         top: position.openUpwards ? `${position.top}px` : `${position.top}px`,
//         left: `${position.left - 130}px`,
//         transform: position.openUpwards ? "translateY(-100%)" : "none",
//       }}
//       ref={menuRef}
//     >
//       <button
//         className="w-full flex items-center gap-3 py-2 px-3 cursor-pointer transition-all duration-200 rounded-md hover:bg-gray-100 text-[#71717A] outline-none"
//         onClick={() => {
//           setSelectedFilePreview({ pdf_url: item.file_url || item.pdf_url, file_type: item.file_type, name: item.name });
//           closeMenu();
//         }}
//       >
//         <div className="flex items-center justify-center"><PreviewIcon /></div>
//         <span className="font-medium text-[14px] font-outfit">Preview</span>
//       </button>

//       <button
//         className="w-full flex items-center gap-3 py-2 px-3 cursor-pointer transition-all duration-200 rounded-md hover:bg-gray-100 text-[#71717A] outline-none"
//         onClick={() => {
//           handleRenameClick(item);
//           closeMenu();
//         }}
//       >
//         <div className="flex items-center justify-center"><RenameIcon /></div>
//         <span className="font-medium text-[14px] font-outfit">Rename</span>
//       </button>

//       {/* Move to Folder option only active for files inside 'All Files' */}
//       {showMoveToFolder && (
//         <button
//           className="w-full flex items-center gap-3 py-2 px-3 cursor-pointer transition-all duration-200 rounded-md hover:bg-gray-100 text-[#71717A] outline-none"
//           onClick={() => {
//             if (handleSingleMoveToFolder) handleSingleMoveToFolder(item);
//             closeMenu();
//           }}
//         >
//           <div className="flex items-center justify-center"><MoveFolderIcon /></div>
//           <span className="font-medium text-[14px] font-outfit">Move to Folder</span>
//         </button>
//       )}

//       {/* FIX: Conditionally render "View & Ingest" only if NOT ingested */}
//       {!isIngested && (
//         <button
//           className="w-full flex items-center gap-3 py-2 px-3 cursor-pointer transition-all duration-200 rounded-md hover:bg-gray-100 text-[#71717A] outline-none"
//           onClick={() => {
//             if (handleViewAndIngest) handleViewAndIngest(item);
//             closeMenu();
//           }}
//         >
//           <div className="w-4 h-4 flex items-center justify-center"><ViewIngestIcon /></div>
//           <span className="font-medium text-[14px] font-outfit">View & Ingest</span>
//         </button>
//       )}

//       <button
//         className="w-full flex items-center gap-3 py-2 px-3 cursor-pointer transition-all duration-200 rounded-md hover:bg-gray-100 text-[#71717A] outline-none"
//         onClick={() => {
//           handleDownload(item);
//           closeMenu();
//         }}
//       >
//         <div className="flex items-center justify-center"><DownloadIcon /></div>
//         <span className="font-medium text-[14px] font-outfit">Download</span>
//       </button>

//       <button
//         className="w-full flex items-center gap-3 py-2 px-3 cursor-pointer transition-all duration-200 rounded-md hover:bg-red-100 text-red-500 hover:text-red-600 outline-none"
//         onClick={(e) => {
//           e.stopPropagation();
//           e.preventDefault();
//           handleDelete(item);
//           closeMenu();
//         }}
//       >
//         <div className="w-4 h-4 flex items-center justify-center"><DeleteIcon /></div>
//         <span className="font-medium text-[14px] font-outfit">Delete</span>
//       </button>
//     </div>
//   );
// };
// export default ActionMenu;

import React, { useEffect, useRef } from "react";
import {
  PreviewIcon,
  RenameIcon,
  DownloadIcon,
  DeleteIcon,
  ViewIngestIcon,
  MoveFolderIcon,
  RemoveFromFolderIcon,
} from "./Icons";
import ReviewerActionGate from "../../../components/ReviewerActionGate";

const ActionMenu = ({
  item,
  position,
  menuRef,
  setSelectedFilePreview,
  handleRenameClick,
  handleDownload,
  handleDelete,
  handleViewAndIngest,
  handleSingleMoveToFolder,
  handleRemoveFromFolder,
  closeMenu,
  isReviewer = false,
}) => {
  const showMoveToFolder = !item.isFolder;
  const isIngested = item?.status?.toLowerCase() === "ingested";

  // Dynamically compute safe left position so menu never clips on the right edge
  const MENU_WIDTH = 192; // w-48 = 12rem = 192px
  const safeLeft = Math.min(
    position.left - MENU_WIDTH + 32, // align near the trigger button
    window.innerWidth - MENU_WIDTH - 8 // clamp to viewport right edge with 8px margin
  );

  return (
    <div
      className="fixed z-[9999] w-48 p-1.5 bg-white border border-[#E5E7EB] rounded-lg shadow-lg flex flex-col gap-0.5"
      style={{
        top: position.openUpwards
          ? `${position.top}px`
          : `${position.top}px`,
        left: `${safeLeft}px`,
        // When open upwards, shift the menu up by its full height using translateY
        transform: position.openUpwards ? "translateY(-100%)" : "none",
      }}
      ref={menuRef}
    >
      <button
        className="w-full flex items-center gap-3 py-2 px-3 cursor-pointer transition-all duration-200 rounded-md hover:bg-gray-100 text-[#71717A] outline-none"
        onClick={() => {
          setSelectedFilePreview({
            pdf_url: item.file_url || item.pdf_url,
            file_type: item.file_type,
            name: item.name,
          });
          closeMenu();
        }}
      >
        <div className="flex items-center justify-center">
          <PreviewIcon />
        </div>
        <span className="font-medium text-[14px] font-outfit">Preview</span>
      </button>

      <ReviewerActionGate active={isReviewer} block place="left">
        <button
          className="w-full flex items-center gap-3 py-2 px-3 cursor-pointer transition-all duration-200 rounded-md hover:bg-gray-100 text-[#71717A] outline-none"
          onClick={() => {
            handleRenameClick(item);
            closeMenu();
          }}
        >
          <div className="flex items-center justify-center">
            <RenameIcon />
          </div>
          <span className="font-medium text-[14px] font-outfit">Rename</span>
        </button>
      </ReviewerActionGate>

      {showMoveToFolder && (
        <ReviewerActionGate active={isReviewer} block place="left">
          <button
            className="w-full flex items-center gap-3 py-2 px-3 cursor-pointer transition-all duration-200 rounded-md hover:bg-gray-100 text-[#71717A] outline-none"
            onClick={() => {
              if (handleSingleMoveToFolder) handleSingleMoveToFolder(item);
              closeMenu();
            }}
          >
            <div className="flex items-center justify-center">
              <MoveFolderIcon />
            </div>
            <span className="font-medium text-[14px] font-outfit">
              Move to Folder
            </span>
          </button>
        </ReviewerActionGate>
      )}

      {handleRemoveFromFolder && (
        <ReviewerActionGate active={isReviewer} block place="left">
          <button
            className="w-full flex items-center gap-3 py-2 px-3 cursor-pointer transition-all duration-200 rounded-md hover:bg-gray-100 text-[#71717A] outline-none"
            onClick={() => {
              handleRemoveFromFolder([item]);
              closeMenu();
            }}
          >
            <div className="flex items-center justify-center">
              <RemoveFromFolderIcon />
            </div>
            <span className="font-medium text-[14px] font-outfit whitespace-nowrap">
              Remove from folder
            </span>
          </button>
        </ReviewerActionGate>
      )}

      {!isIngested && (
        <ReviewerActionGate active={isReviewer} block place="left">
          <button
            className="w-full flex items-center gap-3 py-2 px-3 cursor-pointer transition-all duration-200 rounded-md hover:bg-gray-100 text-[#71717A] outline-none"
            onClick={() => {
              if (handleViewAndIngest) handleViewAndIngest(item);
              closeMenu();
            }}
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <ViewIngestIcon />
            </div>
            <span className="font-medium text-[14px] font-outfit">
              View & Ingest
            </span>
          </button>
        </ReviewerActionGate>
      )}

      <button
        className="w-full flex items-center gap-3 py-2 px-3 cursor-pointer transition-all duration-200 rounded-md hover:bg-gray-100 text-[#71717A] outline-none"
        onClick={() => {
          handleDownload(item);
          closeMenu();
        }}
      >
        <div className="flex items-center justify-center">
          <DownloadIcon />
        </div>
        <span className="font-medium text-[14px] font-outfit">Download</span>
      </button>

      <ReviewerActionGate active={isReviewer} block place="left">
        <button
          className="w-full flex items-center gap-3 py-2 px-3 cursor-pointer transition-all duration-200 rounded-md hover:bg-red-100 text-red-500 hover:text-red-600 outline-none"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleDelete(item);
            closeMenu();
          }}
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <DeleteIcon />
          </div>
          <span className="font-medium text-[14px] font-outfit">Delete</span>
        </button>
      </ReviewerActionGate>
    </div>
  );
};

export default ActionMenu;